import { locationIdFormat } from "@redotech/redo-model/ids";
import { PickSessionSchema } from "@redotech/redo-model/wms/schema/pick-session";
import * as z from "zod/v4";

export const getActiveUserPickSessions = {
  name: "getActiveUserPickSessions" as const,
  input: z.object({ crdbLocationId: locationIdFormat.schema }),
  output: z.object({ pickSessions: z.array(PickSessionSchema) }),
};
